export default __webpack_public_path__ + "static/media/10_long.7e37f8d1.svg";